// extracted by mini-css-extract-plugin
export default {"popup_wrap":"ElectricityPrice_popup_wrap__Hexmv","content_popup":"ElectricityPrice_content_popup__r1CoN","button_wrap":"ElectricityPrice_button_wrap__1OVpD"};